import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './AuthProvider';
import { fetchAndGetCSRFToken, getCSRFToken } from './utils/csrf';

function MFAVerify() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useContext(AuthContext);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await fetchAndGetCSRFToken();
      const csrfToken = getCSRFToken();
      await axios.post('/api/auth/mfa/reverify', { code }, {
        headers: { 'X-CSRFToken': csrfToken },
        withCredentials: true,
      });
      await refreshUser();
      navigate('/career-associates/');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Verification failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-4">Re-enter Authenticator Code</h2>
        <p className="mb-4 text-sm text-gray-600">
          Your session is active, but MFA verification is required before continuing.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">Authenticator Code</label>
            <input
              type="text"
              value={code}
              onChange={e => setCode(e.target.value)}
              required
              className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-6 bg-indigo-600 text-white rounded-md shadow hover:bg-indigo-700 transition-all"
          >
            {loading ? 'Verifying...' : 'Continue'}
          </button>
          {error && <div className="mt-4 text-red-600 text-center">{error}</div>}
        </form>
      </div>
    </div>
  );
}

export default MFAVerify;
